import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  left: ${(props) => props.left}px;
  top: ${(props) => props.top}px;
  display: ${(props) => (props.show ? '' : 'none')};
  z-index: 12;
`;

const ModalContainer = styled.div`
  position: fixed;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

export {
  Container,
  ModalContainer,
};
